import { CardTitle } from "react-migration/components/CardTitle";

export function PlanningApplicationSelectionTitle() {
  return <CardTitle>Planning Applications</CardTitle>;
}
